export default "__VITE_ASSET__8f232335__"